// EN / عربي in the dashboard top bar, on every page (utils/ui-language.js). Studio
// segmented switch.
import React from 'react'
import { useUiLang } from 'utils/ui-language'
import { useT } from 'utils/i18n'

function LanguageSwitch() {
  const [lang, setLang] = useUiLang()
  const { t } = useT()

  const option = (value, label) => (
    <button
      type='button'
      role='radio'
      aria-checked={lang === value}
      onClick={() => setLang(value)}
      className={`min-h-[32px] px-[11px] py-[7px] rounded-[6px] text-[11px] font-semibold whitespace-nowrap transition-colors duration-ui ${
        lang === value ? 'bg-surface text-ink shadow-[0_1px_4px_#21162c16]' : 'text-[#514b59] hover:bg-white/60'
      }`}
      lang={value}
    >
      {label}
    </button>
  )

  return (
    <div role='radiogroup' aria-label={t('Interface language', 'لغة الواجهة')} className='inline-flex gap-0.5 p-[3px] rounded-[9px] bg-segment'>
      {option('en', 'EN')}
      {option('ar', 'عربي')}
    </div>
  )
}

export default LanguageSwitch
